import { render, staticRenderFns } from "./ProductGroupDeleteButton.vue?vue&type=template&id=1842fe42&scoped=true&"
import script from "./ProductGroupDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupDeleteButton.vue?vue&type=style&index=0&id=1842fe42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842fe42",
  null
  
)

export default component.exports